import { useEffect, useState } from "react";

function pad(n) { return String(n).padStart(2, "0"); }

export default function Countdown({ to, onComplete, className = "" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const target = new Date(to).getTime();
  const diff = Math.max(0, target - now);
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const mins = Math.floor((diff % 3600000) / 60000);
  const secs = Math.floor((diff % 60000) / 1000);

  useEffect(() => {
    if (diff <= 0 && onComplete) onComplete();
  }, [diff, onComplete]);

  return (
    <div className={`flex items-end gap-3 font-mono-ds ${className}`} data-testid="countdown">
      {days > 0 && (
        <Block label="D" value={pad(days)} />
      )}
      <Block label="HR" value={pad(hours)} />
      <Block label="MIN" value={pad(mins)} />
      <Block label="SEC" value={pad(secs)} />
    </div>
  );
}

function Block({ label, value }) {
  return (
    <div className="flex flex-col items-center">
      <div className="text-5xl sm:text-6xl font-bold tracking-tighter text-[#FF6A00] drop-shadow-[0_4px_12px_rgba(17,17,17,0.06)] leading-none">
        {value}
      </div>
      <div className="text-[10px] uppercase tracking-[0.3em] text-[#6E6E6E] mt-1">{label}</div>
    </div>
  );
}
